// ControlDatePickerView.js
import $ from 'jquery';
import datepicker from 'jquery-ui/ui/widgets/datepicker.js';
import { View } from 'backbone';
import eventBus         from 'EventBus.js';

import BaseControlView from 'BaseControlView.js';
import constants        from "Constants.js";
import template from 'common-inputs/control_date_calendar.ejs';
import dateUtil from 'shared/DateUtil.js';
import util from 'util/Util.js';

//=====================================================================
//
// An instance of this view represents a date picker control.
// (Named "Date Calendar" in Perfect Forms. Still looking for 
// another kind of calendar).
// The HTML 4 player renders a JQuery-UI date dialog, so that's what
// we use here.
//
// Lou Mauget, December 9, 2015
//
//=====================================================================
class DateCalendarControlView extends BaseControlView  {

        initialize( opts ) {

            super.initialize( opts );
            this.template = template;
            this.tagName = 'div';
            this.family = constants.CONTROL_COMMON_INPUTS;
            this.icon = 'pf-calendar';
            this.events = {
            };

            _.bindAll(this, 'render', 'afterRender');
            var _this = this;
            this.render = _.wrap(this.render, function(render){
                render().bind(_this);
                _this.afterRender();
                return _this;
            });

            this.listenTo(this.model, 'change', this.render);
            this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender);

            return this;
        }

        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'DateCalendarControlView';
        }

        _injectDatePicker() {
            const idSelector = constants.ID_SEL + this.model.attributes.id;
    		const $dp = $( `${idSelector} > ${constants.INSTANCE_CORE_CLASS}`);
            var renderDate = new Date();
            if(!this.model.get('dateValue')){
                if (util.isTrue(this.model.get('showNow'))){
                    renderDate = dateUtil.getFormattedDate(new Date(),'MM/DD/YYYY');
                }else{
                    renderDate = dateUtil.getFormattedDate(this.model.get('specific'),'MM/DD/YYYY');
                }
            }else{
                renderDate = this.model.get('dateValue');
            }
            console.log(renderDate);

			$dp.datepicker({
    			changeYear: true, 
    			changeMonth: true, 
    			gotoCurrent: true,
    			defaultDate: renderDate,
                dayNamesMin: Date.CultureInfo.firstLetterDayNames,
			    beforeShow: function( opts ){
                     setTimeout(function(){
                        $('.ui-datepicker').css('z-index', constants.Z_INDEX_CALENDAR);
                    }, 0);
			    }
			});
            $dp.datepicker('disable');
            const height=Number(this.model.get('height'));
            const width=Number(this.model.get('width'));
            $(`${idSelector} .ui-datepicker`).css('width',width).css('height',height);

            const headerHeight = Number(this.model.get("fontSize")) * 2.5;
            const paddingFactor = 1.5;
            const $calendarItem = $(`${idSelector} .ui-datepicker td a`);
            const $activeItem = $(`${idSelector} .ui-state-active`);
            
            $calendarItem.removeClass("ui-state-highlight");
            $activeItem.removeClass("ui-state-active");
            $activeItem.addClass("ui-state-highlight");
                  
            $calendarItem.css({ 'width': width / 10 - paddingFactor + 'pt', 
                                'height': (height - headerHeight) / 10 - paddingFactor + 'pt'});
            return this;
        }

        render() {
            super.render( this.template );

            return this._injectDatePicker();
        }

        afterRender() {
            const idSelector = constants.ID_SEL + this.model.attributes.id;
            let props = this.model.toJSON();
            //Resolve font properties and apply them to header and boddy
            this.resolveFontProps(props);
            $(`${idSelector} .ui-datepicker`).css('font-family', props.fontFamily);
            $(`${idSelector} .ui-datepicker`).css('font-size', props.fontSize);
            $(`${idSelector} .ui-datepicker`).css('font-style', props.textStyle);
            $(`${idSelector} .ui-datepicker`).css('font-weight', props.textWeight);

            $(`${idSelector} .ui-datepicker .ui-datepicker-header`).css('font-family', props.fontFamily);
            $(`${idSelector} .ui-datepicker .ui-datepicker-header`).css('font-size', props.fontSize);
            $(`${idSelector} .ui-datepicker .ui-datepicker-header`).css('font-style', props.textStyle);
            $(`${idSelector} .ui-datepicker .ui-datepicker-header`).css('font-weight', props.textWeight);

            $(`${idSelector} .ui-datepicker`).css('color', props.styleColorText);
            $(`${idSelector} .ui-datepicker .ui-datepicker-header`).css('color', props.styleColorText);
            $(`${idSelector} .ui-datepicker .ui-state-default, .ui-widget-content`).css('color', props.styleColorText);

            // resolve background color and apply
            this.resolveBackgroundProps(props);
            $(`${idSelector} .ui-datepicker`).css('background-color', props.backgroundColor);

            // Adding css background style for highlight the day that is being picked.
            $(`${idSelector} .ui-datepicker-header.ui-state-disabled`).css('opacity',1);
            $(`${idSelector} .ui-datepicker-calendar.ui-state-disabled`).css('opacity',1);

        }
}

export default DateCalendarControlView;
